/**
 * 購入フロー中のアンケート画面（Survey）への遷移先ルートを組み立てる
 * @param {Object} bookGroup
 * @param {Object} masterBook
 * @returns {Object} vue-router の router.push に渡すルートオブジェクト
 */
export const buildSurveyRoute = (bookGroup, masterBook) => ({
  name: "Survey",
  params: {
    book_group_id: bookGroup.id,
    master_book_id: masterBook.id,
    master_survey_id: bookGroup.master_survey_id,
  },
});
